import { Component, OnDestroy, ViewChild } from '@angular/core';
import { Nav, NavController, NavParams, ModalController } from 'ionic-angular';
import {DataProvider} from "../../providers/data/data";
import {objectAssign} from "@ionic/app-scripts";
import {environment} from '../../environments/environment';
import {HttpClient} from '@angular/common/http';
import { BarcodeScanner } from '@ionic-native/barcode-scanner';
import {OrdersPage} from "../orders/orders";
import {PvPage} from "../pv/pv";

import {PrintPage} from "../print/print";
import {OrderPage} from "../order/order";

/**
 * Generated class for the OrderPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-pvs',
  templateUrl: 'pvs.html',
})
export class PvsPage implements OnDestroy {
  @ViewChild(Nav) nav: Nav;

  pv = null;
  title = 'wird geladen...';

  nummer = null;

  anzahl = null;

  constructor(public navCtrl: NavController, public navParams: NavParams, public data: DataProvider, public http: HttpClient, private barcodeScanner: BarcodeScanner, public modalCtrl: ModalController) {
  }


  ionViewDidLoad() {
  }

  ngOnDestroy() {
    this.data.loadList();
  }

  scan() {
    this.barcodeScanner.scan({torchOn: true}).then((barcodeData) => {
      let scanned_pv = '0';
      if (barcodeData.format === 'QR_CODE') {
        const bstring = barcodeData.text.split('#');
        if (bstring[1] !== undefined) {
          scanned_pv = bstring[1];
        }
      }
      if (barcodeData.format === 'CODE_39') {
        scanned_pv = barcodeData.text;
      }
      this.load(scanned_pv);
    }, (err) => {

    });
  }

  load(number) {
    const body = {
      token: localStorage.getItem('token'),
      module: 'packages',
      submodule: 'load',
      data: {id: number}
    };
    this.http.post(environment.api_url, body).subscribe(daten => {
        this.pv = daten['data'];
        if (this.pv.art !== undefined) {
          this.title = this.pv.art + ' ' + this.pv.nummer + ' ' + this.pv.ort;
        } else {
          alert("Keine passende Packvorschrift gefunden.");
          this.navCtrl.setRoot(OrdersPage);
        }
      }, error => {
      }
    );
  }

  auftrag() {
    let active = {
      id: 'new',
      pv_id: this.pv.id,
      anzahl: this.anzahl,
      erledigt: 0,
    };
    const body = {
      token: localStorage.getItem('token'),
      module: 'orders',
      submodule: 'save',
      data: active
    };
    if (this.anzahl > 0) {
      this.http.post(environment.api_url, body).subscribe(daten => {
        this.navCtrl.setRoot(OrdersPage);
        }, error => {
        }
      );
    }
  }

  openPv(number) {
    this.navCtrl.push(PvPage, {
      item: number
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/pvs/pvs.ts